const loadingMarkup = `
  <div class="product-details__loading">
    <div class="loading-spinner">
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 612 612"
        class="icon--spinner"
        style="enable-background:new 0 0 612 612;"
      >
        <circle
          style="opacity:0.1"
          fill="#000000"
          class="st0"
          cx="304.8"
          cy="313.5"
          r="256.4"
        />
        <path
          fill="#FEDD2F"
          d="M247.8,99.8c0,0,1.1-2.6,26.7-6.4c21.1-3.4,28.2-3,31.2-2.9c4.4,0.1,6.9,0.1,26.2,2.3s30.6,5.7,30.6,5.7
    l0.6,79.6l-52.9,89.2l-5.1,3.2l-5.7-3.2l-52.9-88.5L247.8,99.8z"
        />
      </svg>
    </div>
  </div>
`;

class ProductDetailsDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.closeButton = this.querySelector("[data-close]");
    this.trigger = this.querySelector('[data-trigger]');
    this.drawer = this.querySelector("[data-drawer]");
    this.content = this.querySelector("[data-content]");

    this.closeButton?.addEventListener("click", () => this._close());
    this.trigger?.addEventListener("click", () => this._open());
    this.trigger?.addEventListener("mouseenter", () => this._populate());

    this.documentClick = (e) => {
      if (this.contains(e.target)) return;

      this._close();
    }
    document.addEventListener("click", this.documentClick);

    this.closeEsc = (e) => {
      if (e.key === "Escape") {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    this.addEventListener('click', e => e.stopPropagation());
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("click", this.documentClick);
  }

  get url() {
    return this.getAttribute('url');
  }

  _toggle() {
    'open' in this.drawer.dataset ? this._close() : this._open();
  }

  _populate() {
    if (this.contentMarkup) {
      this.content.innerHTML = this.contentMarkup;
      return;
    };

    this.content.innerHTML = loadingMarkup;

    if (this.loading) return;

    this.loading = true;

    window
      .fetchPageData({ path: this.url, options: { sectionId: 'product-details' } })
      .then(html => {
        this.contentMarkup = html;
        this.content.innerHTML = html;
      })
      .catch(() => { this.loading = false });
  }

  _open() {
    if ('open' in this.drawer.dataset) return;
    this._populate();

    // We have to reparent the drawer so it appears at the right z-index (above header and dimmer)
    // without changing the z-index of the form (appears below header);
    document.body.append(this.drawer);
    this.drawer.style.display = "block";
    document.body.classList.add('product-details-drawer-open');
    window.requestAnimationFrame(() => {
      this.drawer.dataset.open = '';
      this.setAttribute("open", "");
      window.lockScroll(this);
      window.openDimmer(this);
      this.returnFocusEl = document.activeElement;
      window.trapFocus(this.drawer, this.closeButton);
    });
  }

  _close() {
    if (!('open' in this.drawer.dataset)) return;
    delete this.drawer.dataset.open;

    window.closeDimmer(this);
    const onEnd = () => {
      this.drawer.removeEventListener("transitionend", onEnd);

      if ('open' in this.drawer.dataset) return;

      this.drawer.style.display = null;
      this.append(this.drawer);
      window.removeTrapFocus(this.returnFocusEl);
      window.unlockScroll(this);
    };
    this.drawer.addEventListener("transitionend", onEnd);
  }
}

if (!customElements.get("product-details-drawer")) {
  customElements.define("product-details-drawer", ProductDetailsDrawer);
}
